// Event names for the Entri custom-domain connection flow.
// Single source of truth — import from here at every call site so renames stay
// in sync and a typo can't silently split an event into two.
export const ENTRI_EVENTS = {
  /** User clicked "Connect Domain" and the Entri modal was opened. */
  CONNECT_OPENED: "custom_domain_entri_opened",
  /** Entri reported a successful DNS configuration (onSuccess). */
  CONNECT_SUCCEEDED: "custom_domain_entri_succeeded",
} as const;

export type EntriEvent = (typeof ENTRI_EVENTS)[keyof typeof ENTRI_EVENTS];
